import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=007d4e20&scoped=true&"
import script from "./Administrator.vue?vue&type=script&lang=js&"
export * from "./Administrator.vue?vue&type=script&lang=js&"
import style0 from "./Administrator.vue?vue&type=style&index=0&id=007d4e20&lang=less&scoped=true&"
import style1 from "./Administrator.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d4e20",
  null
  
)

export default component.exports